import tinymce from 'tinymce';

// Import TinyMCE themes and plugins
import 'tinymce/themes/silver';
import 'tinymce/icons/default';

// Import plugins
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/code';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/media';
import 'tinymce/plugins/table';
import 'tinymce/plugins/help';
import 'tinymce/plugins/wordcount';
import 'tinymce/models/dom';
import 'tinymce/plugins/help/js/i18n/keynav/ru.js'
import 'tinymce-i18n/langs7/ru';

// Initialize TinyMCE
document.addEventListener('DOMContentLoaded', function() {
  tinymce.init({
    selector: '.tinymce',
    height: 500,
    language: 'ru',
    license_key: 'gpl',
    toolbar: 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | image | bullist numlist outdent indent | removeformat | code',
    plugins: [
      'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview', 'anchor',
      'searchreplace', 'visualblocks', 'code', 'fullscreen',
      'insertdatetime', 'media', 'table', 'help', 'wordcount'
    ],
    mobile: {
      menubar: true,
      plugins: 'autosave lists autolink',
      toolbar: 'undo bold italic styleselect underline link unlink image bullist numlist fontsizeselect forecolor removeformat'
    },
    images_upload_url: '/uploader/image',
    file_picker_types: 'image',
    automatic_uploads: false,
    image_advtab: true,
    skin_url: '/tinymce/skins/ui/oxide',
    content_css: '/tinymce/skins/content/default/content.css'
  });
});

export default tinymce;
